import {
  type BackgroundColor,
  type ColorGroup,
  type TextColor,
  colors,
} from '@lib/colors/colors'

export type FooterColorConfig = {
  backgroundColor: BackgroundColor | string | undefined
  headerColor: TextColor
  iconColor: TextColor
  logoColor: string
  textColor: TextColor
}

export function getFooterColorConfigFromColorGroup(
  colorGroup: ColorGroup,
): FooterColorConfig {
  switch (colorGroup) {
    case 'blue':
      return {
        backgroundColor: 'bg-blue800',
        headerColor: 'text-blue200',
        iconColor: 'text-blue200',
        logoColor: colors.white,
        textColor: 'text-white',
      }
    case 'neutral':
      return {
        backgroundColor: 'bg-neutral900',
        headerColor: 'text-primary200',
        iconColor: 'text-primary200',
        logoColor: colors.neutral200,
        textColor: 'text-white',
      }
    case 'warm':
      return {
        backgroundColor: 'bg-warm100',
        headerColor: 'text-warm700',
        iconColor: 'text-warm700',
        logoColor: colors.warm700,
        textColor: 'text-warm900',
      }
    default:
      return {
        backgroundColor: 'bg-footerPurple',
        headerColor: 'text-primary200',
        iconColor: 'text-primary200',
        logoColor: colors.neutral200,
        textColor: 'text-white',
      }
  }
}
